import type { FloatingNotchMetrics } from './types';

export const FLOATING_ICON_SELECTOR = '.floating .icon-container';

export const measureFloatingNotch = (tabBar: HTMLElement): FloatingNotchMetrics | null => {
  const floatingIcon = tabBar.querySelector(FLOATING_ICON_SELECTOR);

  if (!floatingIcon) {
    return null;
  }

  const tabBarRect = tabBar.getBoundingClientRect();
  const iconRect = floatingIcon.getBoundingClientRect();
  const centerX = iconRect.left + iconRect.width / 2 - tabBarRect.left;

  return { centerX, height: tabBarRect.height, width: tabBarRect.width };
};
